import React, { Component } from "react";
import DeleteDialog from "../../components/DeleteDialog";
import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from "@material-ui/icons/Delete";
import { languages } from "../../constants/languages";

class DeleteInfoFieldContainer extends Component {
  state = {
    open: false,
  };

  toggleDialog = () => {
    this.setState({ open: !this.state.open });
  };

  handleDelete = () => {
    const tournamentRef = window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"]);

    let newInfoFields = this.props.tournament.infoFields || {};
    if (this.props.refereesPage) {
      newInfoFields = this.props.tournament.infoFieldsReferees || {};
    } else if (this.props.playersPage) {
      newInfoFields = this.props.tournament.infoFieldsPlayers || {};
    }
    delete newInfoFields[this.props.infoFieldId];

    let toUpdate = {};
    if (this.props.refereesPage) {
      toUpdate["infoFieldsReferees"] = newInfoFields;
    } else if (this.props.playersPage) {
      toUpdate["infoFieldsPlayers"] = newInfoFields;
    } else {
      toUpdate["infoFields"] = newInfoFields;
    }

    tournamentRef.update(toUpdate);
  };

  render() {
    return (
      <div>
        <IconButton
          aria-label="Change"
          onClick={this.toggleDialog}
          disabled={this.props.disabled}
          style={{ height: 30, width: 30, paddingLeft: 5 }}
        >
          <DeleteIcon
            style={{ height: 20, width: 20, position: "absolute", top: 5 }}
          />
        </IconButton>
        <DeleteDialog
          open={this.state.open}
          toggleDialog={this.toggleDialog}
          handleDelete={this.handleDelete}
          errorMessage={this.state.errorMessage}
          title={languages.teamInfo.deleteInfoField}
          description={languages.teamInfo.deleteWarning}
        />
      </div>
    );
  }
}

export default DeleteInfoFieldContainer;
